
/**
 * Returns the extension of the given uri
 * @module extension
 * @category url
 * @param {string} uri - The uri
 */
export default function extension(uri){
	if(!uri) return "";
    var a = uri.split(".");
    if( a.length === 1 || ( a[0] === "" && a.length === 2 ) )
        return "";
    return a.pop();
};
export { extension };